import React, { memo, useMemo } from 'react';

import { Box, Typography } from '@mui/material';
import { TableCDS } from '@sharedCR/coreDesignSystem/Table';
import PropTypes from 'prop-types';

import { cicFeeChangePropTypes } from '../../LoanCicHistory.propTypes';

import { getCicFeeChangesTableConfig } from './CicFeeChangesTable.config';
import { subheaderStyles } from './CicFeeChangesTable.styles';
import { getHasEditableFeeChanges } from './CicFeeChangesTable.utils';

const CicFeeChangesTable = ({
  feeChanges,
  title = '',
  dataTestId = null,
  isEditAllowed = false,
  onEdit = null,
}) => {
  const hasActions = !!onEdit && getHasEditableFeeChanges({ feeChanges, isEditAllowed });

  const config = useMemo(
    () => getCicFeeChangesTableConfig({ hasActions, isEditAllowed, onEdit }),
    [hasActions, isEditAllowed, onEdit],
  );

  return (
    <Box data-testid={dataTestId}>
      {!!title && (
        <Typography component="div" sx={subheaderStyles} variant="bold14">
          {title}
        </Typography>
      )}
      <TableCDS config={config} data={feeChanges} />
    </Box>
  );
};

CicFeeChangesTable.propTypes = {
  feeChanges: PropTypes.arrayOf(cicFeeChangePropTypes).isRequired,
  dataTestId: PropTypes.string,
  isEditAllowed: PropTypes.bool,
  title: PropTypes.string,
  onEdit: PropTypes.func,
};

export default memo(CicFeeChangesTable);
